<p-dialog
  [(visible)]="visible"
  [modal]="true"
  [draggable]="false"
  [resizable]="false"
  [closeOnEscape]="true"
  [dismissableMask]="true"
  [style]="{width: '500px'}"
  styleClass="p-fluid comunica-contributo-dialog"
  [showHeader]="false"
  (onHide)="hideDialog()">

  <div class="dialog-container">
    <div class="dialog-header">
      <div class="header-content">
        <i class="pi pi-money-bill header-icon"></i>
        <h2>{{ isModifica ? 'MODIFICA contributo' : 'Comunicazione Contributo' }}</h2>
      </div>
      <button
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-rounded p-button-text close-btn"
        (click)="hideDialog()">
      </button>
    </div>

    <div class="card-container" *ngIf="richiesta">
      <p-card styleClass="ente-card">
        <ng-template pTemplate="header">
          <div class="ente-header">
            <h3>{{ richiesta.enteEsecutore.label }}</h3>
            <span class="anno-badge">{{ richiesta.anno }}</span>
          </div>
        </ng-template>

        <div class="card-content">
          <!-- Mostra importo richiesto solo se NON è una modifica -->
          <div class="importo-row" *ngIf="!isModifica">
            <span class="importo-label">Importo Richiesto dall'ente</span>
            <div class="importo-value">
              <div class="custom-chip" [style.background-color]="'#FFF8DC'" [style.border]="'1px solid #c7cd22'">
                <span>{{ formattaImporto(richiesta.importoRichiesto) }}</span>
                <i class="pi pi-euro" [style.color]="'#c7cd22'" style="margin-left: 6px;"></i>
              </div>
            </div>
          </div>

          <p-divider *ngIf="!isModifica"></p-divider>

          <form [formGroup]="contributoForm" class="form-container">
            <div class="field">
              <label for="importoContributo">{{ isModifica ? 'Nuovo Importo Contributo' : 'Importo Contributo' }}</label>
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">€</span>
                <p-inputNumber
                  id="importoContributo"
                  formControlName="importoContributo"
                  placeholder="Inserisci l'importo del contributo"
                  [minFractionDigits]="2"
                  [maxFractionDigits]="2"
                  [min]="1"
                  [showButtons]="false"
                  [style]="{width: '100%', textAlign: 'right'}"
                  [ngClass]="{'ng-invalid ng-dirty': contributoForm.get('importoContributo')?.hasError('importoEccessivo')}"
                  styleClass="contributo-input">
                </p-inputNumber>
              </div>

              <small *ngIf="contributoForm.get('importoContributo')?.hasError('required') && contributoForm.get('importoContributo')?.touched" class="p-error">
                L'importo del contributo è obbligatorio.
              </small>

              <small *ngIf="contributoForm.get('importoContributo')?.hasError('min') && contributoForm.get('importoContributo')?.touched" class="p-error">
                L'importo del contributo deve essere maggiore di zero.
              </small>
            </div>
            <p-divider></p-divider>
            <!-- Campo note solo in modalità modifica -->
            <div class="field" *ngIf="isModifica">
              <label for="note">Note</label>
              <textarea
                id="note"
                pInputTextarea
                formControlName="note"
                [rows]="6"
                [autoResize]="true"
                placeholder="Inserisci eventuali note"
                style="width: 100%; min-height: 150px;">
              </textarea>
            </div>
            <!-- Campo allegato solo in modalità nuova comunicazione -->
            <div class="field" *ngIf="!isModifica">
              <label for="allegato">Allegato PDF da inviare al comune</label>
              <p-fileUpload
                mode="basic"
                multiple="false"
                name="allegato"
                accept="application/pdf"
                [maxFileSize]="1000000"
                uploadLabel="Carica PDF"
                chooseLabel="{{labelPulsante}}"
                chooseIcon="{{iconaPulsante}}"
                uploadIcon="{{iconaPulsante}}"
                uploadLabel="{{labelPulsante}}"
                [styleClass]="classPulsante"
                [auto]="true"
                [customUpload]="true"
                (uploadHandler)="onPDFUpload($event)"
                (onSelect)="onPDFSelect($event)"
                (onRemove)="onPDFRemove()"
                url="https://www.primefaces.org/cdn/api/upload.php"
                [style]="{'width': '100%'}">
                <ng-template pTemplate="content">
                  <div style="width: 100%">
                    <button type="button" pButton [style]="{'width': '100%'}" [icon]="iconaPulsante" [label]="labelPulsante" [class]="classPulsante"></button>
                  </div>
                </ng-template>
              </p-fileUpload>
            </div>
          </form>
        </div>
      </p-card>
    </div>

    <div class="dialog-footer">
      <button
        pButton
        pRipple
        label="Annulla"
        icon="pi pi-times"
        class="p-button-outlined p-button-secondary"
        (click)="hideDialog()">
      </button>
      <button
        pButton
        pRipple
        label="Conferma"
        icon="pi pi-check"
        class="p-button-success"
        [disabled]="contributoForm.invalid || isProcessing"
        (click)="confermaContributo()">
      </button>
    </div>
  </div>

  <!-- Overlay con spinner durante il processing -->
  <div *ngIf="isProcessing" class="processing-overlay">
    <p-progressSpinner
      [style]="{width: '50px', height: '50px'}"
      styleClass="custom-spinner"
      strokeWidth="4"
      fill="var(--surface-ground)"
      animationDuration=".5s">
    </p-progressSpinner>
    <span class="processing-text">Elaborazione in corso...</span>
  </div>
</p-dialog>

<!-- Toast per messaggi di errore - spostato all'esterno del dialog -->
<p-toast key="importoEccessivo" position="center" styleClass="warning-toast center-toast"></p-toast>
